/**
 * Route metadata (fix docket CL5): the facts about a route that used to live in
 * three places — Header's pathname chain for document titles, per-page
 * goBack/title props for the mobile header, and the ad picker's hardcoded
 * denylist. One entry per route; a route with no entry gets the domain's
 * default title, no back arrow, and — deliberately — NO promo banners, so a
 * new payment or recovery page can never ship monetized by omission.
 */
export type RouteMeta = {
  /** i18n id for the document title, and the mobile header title with `back`. */
  titleId?: string;
  /** The mobile header shows the back arrow + title instead of the logo. */
  back?: boolean;
  /** Promo banners may render here. Absent means they may not. */
  ads?: boolean;
};

const ROUTE_META: [pattern: string, meta: RouteMeta][] = [
  ["/", { ads: true }],
  ["/members", { titleId: "menu_desktop__members", ads: true }],
  ["/top", { titleId: "topandprogress__head_title", ads: true }],
  ["/challenge", { titleId: "challenge__head_title", ads: true }],
  ["/challenge/:id", { titleId: "challenge__head_title", ads: true }],
  ["/search", { titleId: "search__head_title", ads: true }],
  ["/webcams", { titleId: "webcam_head_title" }],
  ["/desabonnement", { titleId: "unsub__meta_titre" }],
  ["/contact", { titleId: "menu__contact" }],
  ["/cgus", { titleId: "menu__cgu" }],
  ["/privacy", { titleId: "menu__privacy" }],
  ["/2257", { titleId: "menu__exemption" }],
  ["/dmca", { titleId: "menu__dmca" }],
  ["/myepheme/:id", { titleId: "menu__my_epheme", back: true }],
  ["/help", { titleId: "you__help_legal", back: true }],
  ["/verification", { titleId: "you__verification", back: true }],
];

/** First entry whose pattern matches the pathname; `:segment` is a wildcard. */
export function routeMeta(pathname: string): RouteMeta | undefined {
  const parts = pathname.split("/").filter(Boolean);
  for (const [pattern, meta] of ROUTE_META) {
    const patternParts = pattern.split("/").filter(Boolean);
    if (pattern === "/" && parts.length === 0) return meta;
    if (patternParts.length !== parts.length) continue;
    if (patternParts.every((seg, i) => seg.startsWith(":") || seg === parts[i])) return meta;
  }
  return undefined;
}
